<template>
  <div>
    <a @click="fnShowModal()" v-b-tooltip.hover :title="title">
      <span><i class="las la-copy text-primary fs-1300"></i></span>
    </a>

    <b-modal ref="userModal" hide-footer :title="title">
      <div class="d-block">
        <SectionCreateNewQuote
          v-if="isCreated !== 'openConfirmation'"
          @closeModal="hideModal"
          @quoteCreated="fnQuoteCreated"
          :propsData="propsData"
        ></SectionCreateNewQuote>
        <SectionConfirmNewQuote
          v-if="isCreated === 'openConfirmation'"
          @closeModal="hideModal"
          :propsData="propsData"
          :otherData="otherData"
        ></SectionConfirmNewQuote>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import Multiselect from 'vue-multiselect'
import * as authService from '../../../services/auth.service'
import SectionCreateNewQuote from '../../../components/admin/maturingLeases/SectionCreateNewQuote.vue'
import SectionConfirmNewQuote from '../../../components/admin/maturingLeases/SectionConfirmNewQuote.vue'

export default {
  name: 'CreateNewQuote',
  props: {
    propsData: {
      type: Object,
      required: true
    }
  },
  components: {
    Multiselect,
    SectionCreateNewQuote,
    SectionConfirmNewQuote
  },
  data() {
    return {
      errors: {},
      isCreated: '',
      otherData: {}
    }
  },
  computed: {
    ...mapGetters([
      'getDealerDropdown',
      'getDealerStaffDropdown',
      'getUserById'
    ]),
    title() {
      if (this.isCreated === 'openConfirmation') {
        return 'Confirmation quote created'
      }
      return 'Create new quote'
    }
  },
  methods: {
    ...mapActions([
      'fetchDealerDropdown',
      'fetchDealerStaffDropdown',
      'fetchUserById'
    ]),
    fnShowModal() {
      this.fetchDealerDropdown()
      this.userData = authService.getUserFromToken()
      this.fetchUserById(this.userData.id)
      this.showModal()
    },
    hideModal() {
      this.$refs.userModal.hide()
    },
    showModal() {
      this.$refs.userModal.show()
    },
    fnQuoteCreated(status, otherData) {
      this.isCreated = status
      this.otherData = otherData
    }
  }
}
</script>
